// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uu-X","input":"styles_input__1EVFx"};